<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import appointments from '@/services/api/appointments.api'
import specialistApi from '@/services/api/specialist.api'
import providerApi from '@/services/api/provider.api'
import practitionerApi from '@/services/api/practitioner.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Practicantes e internos',
      routes: ['Informes', 'Practicantes e internos'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          specialists: [],
          practitioners: [],
          providers: [],
          specialties: [],
        },
        filters: {
          academicYear: null,
          specialist: null,
          practitioner: null,
          provider: null,
          specialty: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-3',
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-3',
          disabled: this.model.search.collections.specialists.length <= 0,
          onChanged: this.getPractitionersBySpecialist,
        },
        {
          name: 'practitioner',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Practicantes e internos',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.practitioners,
          value: this.model.search.filters.practitioner,
          class: 'col-md-3',
          disabled: this.model.search.collections.practitioners.length <= 0,
          onChanged: this.getPractitionerSpecialties,
        },
        {
          name: 'specialty',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialidad',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.specialties,
          value: this.model.search.filters.specialty,
          class: 'col-md-3',
          disabled: this.model.search.collections.specialties.length <= 0,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
    },
    async onChangeAcademicYear() {
      this.model.search.filters.specialist = null
      this.model.search.filters.practitioner = null
      this.model.search.filters.provider = null
      this.model.search.filters.specialty = null
      this.model.search.collections.specialists = []
      this.model.search.collections.practitioners = []
      this.model.search.collections.providers = []
      this.model.search.collections.specialties = []
      await this.getProvider()
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null
      this.model.search.filters.practitioner = null
      this.model.search.filters.specialty = null
      this.model.search.collections.specialists = []
      this.model.search.collections.practitioners = []
      this.model.search.collections.specialties = []
      await this.getSpecialist()
    },
    async onHandlerSearch() {
      this.process()
    },
    async getSpecialist() {
      await specialistApi
        .getSpecialistProvider({
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
        })
        .then((res) => {
          this.model.search.collections.specialists = res.data
        })
    },
    async getPractitionersBySpecialist() {
      this.model.search.filters.practitioner = null
      this.model.search.filters.specialty = null
      this.model.search.collections.practitioners = []
      this.model.search.collections.specialties = []
      let specialistId = this.model.search.filters.specialist.id
      let data = await practitionerApi.getPractitionerBySpecialist(specialistId)
      this.model.search.collections.practitioners = data.data
    },
    async getPractitionerSpecialties() {
      this.model.search.filters.specialty = null
      this.model.search.collections.specialties = []
      let practitionerId = this.model.search.filters.practitioner.id
      let data = await practitionerApi.getPractitionerSpecialties(
        practitionerId
      )
      this.model.search.collections.specialties = data.data
    },
    async getMonth() {
      await appointments
        .getAppointmentsFilters({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.months = res.data
        })
    },
    async getProvider() {
      await providerApi
        .getAllProvidertCompaniesByYear({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data

          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
            this.getSpecialist()
          }
        })
    },
    async process() {
      if (this.hasValue(this.model.search.filters.academicYear?.id)) {
        await ReportServices.getReport('reportpractitionerandinterns', {
          CompanyId: this.model.search.filters.provider?.id,
          AcademicYearId: this.model.search.filters.academicYear?.id,
          PractitionerId: this.model.search.filters.practitioner?.id,
          DisciplineTypeId: this.model.search.filters.specialty?.id,
          SpecialistId: this.model.search.filters.specialist?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
  },
}
</script>
